<template lang="pug">
  .profile
    vm-row(vm-w="12")
      vm-col.profile-card(vm-lg=8 vm-sm=12 vm-offset=2)
        .profile-title
          h2 {{ $t('strings.profile') }}
          span {{ $t('strings.profile_description') }}
        .container
          .images-container(:class="!$auth.check('Admin') ? 'jcsp' : 'jcc'")
            profile-image(:src="avatar_url" url="/user/avatar" @response="getAvatarUrl" :title="'Profile Picture'")
            profile-image(:src="company_url" url="/customer/logo" @response="getCompanyLogoUrl" v-if="$auth.check('Customer')" :title="'Company Picture'")
</template>

<script>
import ProfileImage from '../components/aditionals/ProfileImage.vue'
import { required, email } from 'vuelidate/lib/validators'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Customers')

export default {
  name: 'profile',
  components: {
    ProfileImage
  },
  data: () => ({
    form: {
      name: ''
    },
    isDisabled: false,
    avatar_url: null,
    company_url: null
  }),
  validations: {
    form: {
      name: {
        required
      },
      email: {
        email
      },
      phone: {},
      website: {}
    }
  },
  async created () {
    this.avatar_url = this.$auth.user().avatar_photo
    await this.getCustomer()
    if (!this.$auth.check('Admin')) {
      this.company_url = this.$auth.user().company_logo
    }
  },
  methods: {
    ...mapActions([
      'loadCustomer',
      'editCustomer',
      'editUser'
    ]),
    getAvatarUrl (newUrl) {
      this.avatar_url = newUrl
    },
    getCompanyLogoUrl (newUrl) {
      this.company_url = newUrl
    },
    async getCustomer () {
      if (this.$auth.check('Customer')) {
        await this.loadCustomer(this.$auth.user().customer)
        this.form.name = this.customer.name
        this.form.email = this.customer.email
        this.form.phone = this.customer.phone
        this.form.website = this.customer.website
      } else {
        this.form.name = this.$auth.user().name
        this.form.email = this.$auth.user().email
      }
    },
    async submitData () {
      this.isDisabled = true
      if (this.$auth.user().customer) {
        this.form.id = this.$auth.user().customer.id
        await this.editCustomer(this.form)
      } else {
        this.form.id = this.$auth.user().id
        await this.editUser(this.form)
      }
      this.isDisabled = false
    }
  },
  computed: {
    ...mapGetters([
      'customer'
    ])
  }
}
</script>

<style lang="scss" scoped>
.profile {
    width: 100%;
    padding: 0 35px;
}
.profile-card {
    background: white;
    border-radius: 10px;
    padding: 35px;
}
.profile-title {
  width: 100%;
  margin-bottom: 15px;
}
.container {
    width: 400px;
    margin: 0 auto;
}
.images-container {
    max-width: 400px;
    height: 150px;
    display: flex;
    justify-content: space-between;
}
.jcsp {
  justify-content: space-between;
}
.jcc {
  justify-content: center;
}
</style>
